/*
* NAMING CONVENTION
* - OBJECT -> ACTION
* - Do not try to imply location in the events (these can be determine through page events or source strings metadata)
*
* TODO: With the exception of APP_SESSION_START & USER_SESSION_START,
        _START events indicate user click events - Let's just call these _CLICK to be explicitly clear
* TODO: _COMPLETE events indicate API request successes.
*       _ERROR events indicate API request errors.
*       The general consensus now is to not track API request success/fail unless important to Product's insights
*/

export const APP_RENDER_SUCCESS = 'APP_RENDER_SUCCESS';
export const APP_SESSION_START = 'APP_SESSION_START';
export const USER_SESSION_START = 'USER_SESSION_START';
export const USER_SESSION_END = 'USER_SESSION_END';

// Onboarding Events
export const HIDE_ONBOARDING_GUIDE = 'HIDE_ONBOARDING_GUIDE';
export const QUICK_START_GUIDE_LINK_CLICKED = 'QUICK_START_GUIDE_LINK_CLICKED';
export const SHIPSTATION_UNIVERSITY_LINK_CLICKED = 'SHIPSTATION_UNIVERSITY_LINK_CLICKED';
export const SHOW_ONBOARDING_GUIDE = 'SHOW_ONBOARDING_GUIDE';
export const PRINTING_SETUP_START = 'PRINTING_SETUP_START';
export const PRINTING_SETUP_COMPLETE = 'PRINTING_SETUP_COMPLETE';
export const LABEL_LAYOUT_SELECTION_START = 'LABEL_LAYOUT_SELECTION_START';
export const LABEL_LAYOUT_SELECTION_COMPLETE = 'LABEL_LAYOUT_SELECTION_COMPLETE';
export const LABEL_PRINT_SETTINGS_LINK_CLICKED = 'LABEL_PRINT_SETTINGS_LINK_CLICKED';
export const DOCUMENT_OPTIONS_CONFIG_START = 'DOCUMENT_OPTIONS_CONFIG_START';
export const DOCUMENT_OPTIONS_CONFIG_COMPLETE = 'DOCUMENT_OPTIONS_CONFIG_COMPLETE';
export const ONBOARDING_SETUP_EVENT = 'ONBOARDING_SETUP_EVENT';
export const ONBOARDING_CONNECTION_SUCCESS_TOAST_CLICK = 'ONBOARDING_CONNECTION_SUCCESS_TOAST_CLICK';
export const ONBOARDING_CONNECTION_SUCCESS_TOAST_CLOSE = 'ONBOARDING_CONNECTION_SUCCESS_TOAST_CLOSE';

// Buy Now Flow Events
export const BUY_NOW_FLOW_DETECTED = 'BUY_NOW_FLOW_DETECTED';
export const DEFER_BUY_NOW_MODAL_SHOWN = 'DEFER_BUY_NOW_MODAL_SHOWN';
export const DEFER_BUY_NOW_MODAL_BACK_CLICKED = 'DEFER_BUY_NOW_MODAL_BACK_CLICKED';
export const DEFER_BUY_NOW_MODAL_START_CLICKED = 'DEFER_BUY_NOW_MODAL_START_CLICKED';

// Subscription Events
export const CANCEL_SUBSCRIPTION_LINK_CLICKED = 'CANCEL_SUBSCRIPTION_LINK_CLICKED';
export const SUBSCRIPTION_CANCELLATION_COMPLETE = 'SUBSCRIPTION_CANCELLATION_COMPLETE';
export const SUBSCRIPTION_CHANGE_START = 'SUBSCRIPTION_CHANGE_START';
export const SUBSCRIPTION_SUGGESTEDPLAN_SELECTION_BTN = 'SUBSCRIPTION_SUGGESTEDPLAN_SELECTION_BTN';
export const SUBSCRIPTION_UPGRADE_LINK = 'SUBSCRIPTION_UPGRADE_LINK';
export const SUBSCRIPTION_CHANGE_COMPLETE = 'SUBSCRIPTION_CHANGE_COMPLETE';
export const SUBSCRIPTION_CHANGE_ERROR = 'SUBSCRIPTION_CHANGE_ERROR';
export const SUBSCRIPTION_CHANGE_CANCEL = 'SUBSCRIPTION_CHANGE_CANCEL';
export const SUBSCRIPTION_CHANGE_SELECT_PLAN = 'SUBSCRIPTION_CHANGE_SELECT_PLAN';
export const SUBSCRIPTION_CHANGE_COMPARE_FEATURES_CLICK = 'SUBSCRIPTION_CHANGE_COMPARE_FEATURES_CLICK';
export const SUBSCRIPTION_MIGRATION_TAB_SWITCH = 'SUBSCRIPTION_MIGRATION_TAB_SWITCH';
export const SUBSCRIPTION_CHURN_WIN_BACK = 'SUBSCRIPTION_CHURN_WIN_BACK';
export const ANNUAL_BILLING_TOGGLE = 'ANNUAL_BILLING_TOGGLE';
export const ADD_USER_CLICK = 'ADD_USER_CLICK';
export const ADD_USER_CLICK_CONFIRM = 'ADD_USER_SAVE';
export const UNDO_SUBSCRIPTION_CANCELLATION = 'UNDO_SUBSCRIPTION_CANCELLATION';
export const PLAN_TRIAL_BANNER_DISMISS = 'PLAN_TRIAL_BANNER_DISMISS';
export const PLAN_TRIAL_BANNER_UPGRADE_CLICK = 'PLAN_TRIAL_BANNER_UPGRADE_CLICK';
export const PLAN_TRIAL_EXPIRED_BANNER_DISMISS = 'PLAN_TRIAL_EXPIRED_BANNER_DISMISS';
export const PLAN_TRIAL_EXPIRED_BANNER_UPGRADE_CLICK = 'PLAN_TRIAL_EXPIRED_BANNER_UPGRADE_CLICK';

// Premium Trial Offer Events
export const PREMIUM_TRIAL_OFFER_BANNER_DISPLAYED = 'PREMIUM_TRIAL_OFFER_BANNER_DISPLAYED';
export const PREMIUM_TRIAL_OFFER_BANNER_LEARN_MORE_CLICKED = 'PREMIUM_TRIAL_OFFER_BANNER_LEARN_MORE_CLICKED';
export const PREMIUM_TRIAL_OFFER_BANNER_DISMISSED = 'PREMIUM_TRIAL_OFFER_BANNER_DISMISSED';
export const PREMIUM_TRIAL_OFFER_MODAL_OPENED = 'PREMIUM_TRIAL_OFFER_MODAL_OPENED';
export const PREMIUM_TRIAL_OFFER_START_TRIAL_CLICKED = 'PREMIUM_TRIAL_OFFER_START_TRIAL_CLICKED';
export const PREMIUM_TRIAL_OFFER_START_TRIAL_SUCCESS = 'PREMIUM_TRIAL_OFFER_START_TRIAL_SUCCESS';
export const PREMIUM_TRIAL_OFFER_UPGRADE_NOW_CLICKED = 'PREMIUM_TRIAL_OFFER_UPGRADE_NOW_CLICKED';
// TODO: are people even tracking this metric? Also this name is gross
export const CARRIERS_PAGE_LINK_IN_SUBSCRIPTION_BILLING_CLICKED = 'CARRIERS_PAGE_LINK_IN_SUBSCRIPTION_BILLING_CLICKED';
export const ADD_VAT_ID_CLICKED = 'ADD_VAT_ID_CLICKED';
export const ADD_VAT_ID_COMPLETE = 'ADD_VAT_ID_COMPLETE';
export const ADD_VAT_ID_CLOSE = 'ADD_VAT_ID_CLOSE';
export const ADD_VAT_ID_ERROR = 'ADD_VAT_ID_ERROR';

// Integration Events
export const FULFILLMENT_CONNECTION_START = 'FULFILLMENT_CONNECTION_START';
export const FULFILLMENT_CONNECTION_COMPLETE = 'FULFILLMENT_CONNECTION_COMPLETE';
export const WALLET_REGISTRATION_ERROR = 'WALLET_REGISTRATION_ERROR';
export const WALLET_REGISTRATION_START = 'WALLET_REGISTRATION_START';
export const WALLET_REGISTRATION_COMPLETE = 'WALLET_REGISTRATION_COMPLETE';
export const WALLET_REGISTRATION_CANCEL = 'WALLET_REGISTRATION_CANCEL';
export const WALLET_REGISTRATION_INSURE_ALL = 'WALLET_REGISTRATION_INSURE_ALL';
export const TOGGLE_WALLET_LABEL_PROVIDER = 'TOGGLE_WALLET_LABEL_PROVIDER';

// Billing & Funding Events
export const FUND_WALLET_CLICK = 'FUND_WALLET_CLICK';
export const CONFIRM_FUND_WALLET_CLICK = 'CONFIRM_FUND_WALLET_CLICK';
export const FUND_SHIPSURANCE_CLICK = 'FUND_SHIPSURANCE_CLICK';
export const CONFIRM_FUND_SHIPSURANCE_CLICK = 'CONFIRM_FUND_SHIPSURANCE_CLICK';
export const MANAGE_AUTOFUND_CONFIG_CLICK = 'MANAGE_AUTOFUND_CONFIG_CLICK';
export const MANAGE_AUTOFUND_CONFIG_SAVE = 'MANAGE_AUTOFUND_CONFIG_SAVE';
export const UDPATE_RECURLY_BILLING_CLICK = 'UDPATE_RECURLY_BILLING_CLICK';
export const UPDATE_RECURLY_BILLING_SAVE = 'UPDATE_RECURLY_BILLING_SAVE';
export const UDPATE_WALLET_BILLING_CLICK = 'UDPATE_WALLET_BILLING_CLICK';
export const UPDATE_WALLET_BILLING_SAVE = 'UPDATE_WALLET_BILLING_SAVE';
export const FTU_WALLET_BILLING_EDIT_CLICK = 'FTU_WALLET_BILLING_EDIT_CLICK';
export const FTU_WALLET_BILLING_EDIT_SAVE = 'FTU_WALLET_BILLING_EDIT_SAVE';
export const SURCHARGE_CONNECT_BANK_CLICK = 'SURCHARGE_CONNECT_BANK_CONFIRM';

// Create Label Events
export const LABEL_CREATION_ERROR = 'LABEL_CREATION_ERROR';
export const LABEL_CREATION_START = 'LABEL_CREATION_START';
export const LABEL_CREATION_COMPLETE = 'LABEL_CREATION_COMPLETE';
export const LABEL_PRINTING_COMPLETE = 'LABEL_PRINTING_COMPLETE';
export const LABEL_PRINTED = 'LABEL_PRINTED';
export const LABEL_DOWNLOADED = 'LABEL_DOWNLOADED';
export const BULK_LABEL_CREATION_START = 'BULK_LABEL_CREATION_START';
export const BULK_LABEL_CREATION_COMPLETE = 'BULK_LABEL_CREATION_COMPLETE';
export const BULK_LABEL_PRINTING_START = 'BULK_LABEL_PRINTING_START';
export const BULK_LABEL_PRINTING_COMPLETE = 'BULK_LABEL_PRINTING_COMPLETE';
export const PRINT_LABEL_FINISHED = 'PRINT_LABEL_FINISHED';

export const ORDER_DETAILS_ACTION = 'ORDER_DETAILS_ACTION';
export const SPLIT_SHIP_ACTION = 'SPLIT_SHIP_ACTION';
export const ORDER_DETAILS_OPT_OUT_FEEDBACK = 'ORDER_DETAILS_OPT_OUT_FEEDBACK';
export const ADD_EDIT_SHIPMENT_ITEMS_ACTION = 'ADD_EDIT_SHIPMENT_ITEMS_ACTION';
export const DELETE_SHIPMENT_ACTION = 'DELETE_SHIPMENT_ACTION';
export const RESHIP_SHIPMENT_ACTION = 'RESHIP_SHIPMENT_ACTION';
export const ORDER_GRID_BULK_ACTION = 'ORDER_GRID_BULK_ACTION';

// Refresh Selected Orders Events
export const REFRESH_SELECTED_ORDERS_CLICK = 'REFRESH_SELECTED_ORDERS_CLICK';
export const REFRESH_SELECTED_ORDERS_COMPLETE = 'REFRESH_SELECTED_ORDERS_COMPLETE';
export const REFRESH_SELECTED_ORDERS_ERROR = 'REFRESH_SELECTED_ORDERS_ERROR';

// Loss Prevention / Fraud Detection Events
export const FRAUD_INDICATOR_DISMISSED = 'FRAUD_INDICATOR_DISMISSED';

// Uncategorized
export const STORE_ERROR_KB_LINK_CLICK = 'STORE_ERROR_KB_LINK_CLICK';
export const SHOP_SUPPLIES_CLICKED = 'SHOP_SUPPLIES_CLICKED';
export const SUPPLIES_CARD_CLICKED = 'SUPPLIES_CARD_CLICKED';
export const SUPPLIES_CHECKOUT_OPENED = 'SUPPLIES_CHECKOUT_OPENED';
export const SUPPLIES_CHECKOUT_POPUP_BLOCKED = 'SUPPLIES_CHECKOUT_POPUP_BLOCKED';
export const SHOPIFY_SUPPLIES_LINK_CLICKED = 'SHOPIFY_SUPPLIES_LINK_CLICKED';

// Transaction history export event
export const VIEW_BALANCE_HISTORY_START = 'VIEW_BALANCE_HISTORY_START';
export const EXPORT_BALANCE_HISTORY_CLICK = 'EXPORT_BALANCE_HISTORY_CLICK';
export const EXPORT_BALANCE_HISTORY_COMPLETE = 'EXPORT_BALANCE_HISTORY_COMPLETE';

// Coachmark Analytics
export const COACHMARK_OPEN = 'COACHMARK_OPEN';
export const COACHMARK_CLOSE = 'COACHMARK_CLOSE';
export const COACHMARK_SKIP = 'COACHMARK_SKIP';
export const COACHMARK_NEXT = 'COACHMARK_NEXT';
export const COACHMARK_LEARN_MORE = 'COACHMARK_LEARN_MORE';

// Support
export const SUPPORT_SHIPSTATION_UNIVERSITY_CLICKED = 'SUPPORT_SHIPSTATION_UNIVERSITY_CLICKED';

// Your Carriers Feature Events
export const YOUR_CARRIERS_ACTIVATE_MODAL_OPEN = 'YOUR_CARRIERS_ACTIVATE_MODAL_OPEN';
export const YOUR_CARRIERS_ACTIVATE_MODAL_CLOSE = 'YOUR_CARRIERS_ACTIVATE_MODAL_CLOSE';
export const YOUR_CARRIERS_ACTIVATE_COMPLETE = 'YOUR_CARRIERS_ACTIVATE_COMPLETE';
export const YOUR_CARRIERS_DEACTIVATE_COMPLETE = 'YOUR_CARRIERS_DEACTIVATE_COMPLETE';
export const YOUR_CARRIERS_SUBSCRIPTION_LINK_CLICK = 'YOUR_CARRIERS_SUBSCRIPTION_LINK_CLICK';

// Experiment Events
export const EXPERIMENT_VIEWED = 'EXPERIMENT_VIEWED';

// Labs Feature Events
export const LABS_FEATURE_ENABLED = 'LABS_FEATURE_ENABLED';
export const LABS_FEATURE_DISABLED = 'LABS_FEATURE_DISABLED';
export const LABS_FEATURE_FEEDBACK_SUBMITTED = 'LABS_FEATURE_FEEDBACK_SUBMITTED';

// Pack Station rollout (SPD-28197)
export const PACK_STATION_BANNER_ACCEPTED = 'PACK_STATION_BANNER_ACCEPTED';
export const PACK_STATION_BANNER_DISMISSED = 'PACK_STATION_BANNER_DISMISSED';
export const PACK_STATION_FEEDBACK_SUBMITTED = 'PACK_STATION_FEEDBACK_SUBMITTED';

// Add to Batch Menu
export const ADD_TO_BATCH_MENU_OPEN = 'ADD_TO_BATCH_MENU_OPEN';
export const ADD_TO_BATCH_MENU_CLOSE = 'ADD_TO_BATCH_MENU_CLOSE';
export const ADD_TO_BATCH_ITEM_CLICK = 'ADD_TO_BATCH_ITEM_CLICK';

// Rate Shopper
export const RATE_SHOPPER_EXPAND = 'RATE_SHOPPER_EXPAND';
export const RATE_SHOPPER_SAVE = 'RATE_SHOPPER_SAVE';
export const RATE_SHOPPER_DELETE = 'RATE_SHOPPER_DELETE';
export const RATE_SHOPPER_CREATE_NEW = 'RATE_SHOPPER_CREATE_NEW';
export const RATE_SHOPPER_UPSELL_MODAL_OPEN = 'RATE_SHOPPER_UPSELL_MODAL_OPEN';
export const RATE_SHOPPER_MANAGE_CLICK = 'RATE_SHOPPER_MANAGE_CLICK';
export const RATE_SHOPPER_TOGGLE_ACTIVATE = 'RATE_SHOPPER_TOGGLE_ACTIVATE';
export const RATE_SHOPPER_TOGGLE_DEACTIVATE = 'RATE_SHOPPER_TOGGLE_DEACTIVATE';
export const RATE_SHOPPER_USE_TEMPLATE = 'RATE_SHOPPER_USE_TEMPLATE';
export const RATE_SHOPPER_SELECTION_CHANGE = 'RATE_SHOPPER_SELECTION_CHANGE';

// Insurance
export const INSURANCE_PREFERENCE_SELECTION_CHANGE = 'INSURANCE_PREFERENCE_SELECTION_CHANGE';
export const INSURANCE_OPTION_CLICKED = 'INSURANCE_OPTION_CLICKED';
export const INSURANCE_POPOVER_VIEWED = 'INSURANCE_POPOVER_VIEWED';
export const INSURANCE_OPTION_UPDATED = 'INSURANCE_OPTION_UPDATED';
export const FTU_INSURANCE_RULE_CREATED = 'FTU_INSURANCE_RULE_CREATED';
export const FTU_INSURANCE_EXPERIMENT_EXPOSURE = 'FTU_INSURANCE_EXPERIMENT_EXPOSURE';
export const INSURANCE_MODAL_VIEWED = 'INSURANCE_MODAL_VIEWED';
export const INSURANCE_MODAL_BUTTON_CLICKED = 'INSURANCE_MODAL_BUTTON_CLICKED';

// Insurance — standalone step (enable-insurance-promo-standalone variant). Uniquely named
// so the standalone-step funnel can be tracked separately from the combined step.
export const FTU_INSURANCE_STANDALONE_STEP_VIEWED = 'FTU_INSURANCE_STANDALONE_STEP_VIEWED';
export const FTU_INSURANCE_STANDALONE_PREFERENCE_SELECTION_CHANGE = 'FTU_INSURANCE_STANDALONE_PREFERENCE_SELECTION_CHANGE';
export const FTU_INSURANCE_STANDALONE_OPTION_CLICKED = 'FTU_INSURANCE_STANDALONE_OPTION_CLICKED';
export const FTU_INSURANCE_STANDALONE_POPOVER_VIEWED = 'FTU_INSURANCE_STANDALONE_POPOVER_VIEWED';
export const FTU_INSURANCE_STANDALONE_RULE_CREATED = 'FTU_INSURANCE_STANDALONE_RULE_CREATED';
export const FTU_INSURANCE_STANDALONE_OPTION_UPDATED = 'FTU_INSURANCE_STANDALONE_OPTION_UPDATED';

// Products & Inventory
export const INVENTORY_SYNC_AUTO_SYNC_TOGGLE = 'INVENTORY_SYNC_AUTO_SYNC_TOGGLE';
export const INVENTORY_SYNC_AUTO_SYNC_TOGGLE_ERROR = 'INVENTORY_SYNC_AUTO_SYNC_TOGGLE_ERROR';
export const INVENTORY_SYNC_MANUAL_SYNC_CLICK = 'INVENTORY_SYNC_MANUAL_SYNC_CLICK';
export const INVENTORY_SYNC_MANUAL_SYNC_ERROR = 'INVENTORY_SYNC_MANUAL_SYNC_ERROR';
export const INVENTORY_SYNC_TARGETS_FAQ_CLICK = 'INVENTORY_SYNC_TARGETS_FAQ_CLICK';
export const INVENTORY_SYNC_OPEN_SYNC_CONFIG_MODAL = 'INVENTORY_SYNC_OPEN_SYNC_CONFIG_MODAL';
export const INVENTORY_SYNC_OPEN_SYNC_DETAILS_MODAL = 'INVENTORY_SYNC_OPEN_SYNC_DETAILS_MODAL';
export const INVENTORY_PRODUCT_COLUMN_HOVER = 'INVENTORY_PRODUCT_COLUMN_HOVER';
export const SAVE_DANGEROUS_GOODS_IN_PRODUCT = 'SAVE_DANGEROUS_GOODS_IN_PRODUCT';

// Insurance Analytics Events
export const INSURANCE_FIELD_CLICK = 'INSURANCE_FIELD_CLICK';
export const INSURANCE_FIELD_VALUE_UPDATED = 'INSURANCE_FIELD_VALUE_UPDATED';
export const INSURANCE_HYPERLINK_CLICK = 'INSURANCE_HYPERLINK_CLICK';
export const INSURANCE_SETTINGS_TOGGLE = 'INSURANCE_SETTINGS_TOGGLE';
export const INSURANCE_SETTINGS_VIEWED = 'INSURANCE_SETTINGS_VIEWED';
export const INSURANCE_WALLET_TOGGLE = 'INSURANCE_WALLET_TOGGLE';

// Rate Recommendations
export const SHOWED_INSURANCE_RATE_RECOMMENDATION = 'SHOWED_INSURANCE_RATE_RECOMMENDATION';
export const APPLIED_INSURANCE_RATE_RECOMMENDATION = 'APPLIED_INSURANCE_RATE_RECOMMENDATION';
export const APPLY_FROM_CSW = 'APPLY_FROM_CSW';
export const SHOW_FROM_CSW = 'SHOW_FROM_CSW';
export const APPLY_FROM_GRID = 'APPLY_FROM_GRID';
export const SHOW_IN_GRID = 'SHOW_IN_GRID';
export const SHOWED_RATE_SHOPPER_RECOMMENDATION = 'SHOWED_RATE_SHOPPER_RECOMMENDATION';
export const APPLIED_RATE_SHOPPER_RECOMMENDATION = 'APPLIED_RATE_SHOPPER_RECOMMENDATION';

// Rate Shopper Audit
export const RATE_SHOPPER_AUDIT_OPEN = 'RATE_SHOPPER_AUDIT_OPEN';
export const RATE_SHOPPER_AUDIT_LINK_CLICK = 'RATE_SHOPPER_AUDIT_LINK_CLICK';

// Email Verification
export const EMAIL_VERIFICATION_RESEND = 'EMAIL_VERIFICATION_RESEND';

// Fraud Stuff
export const FUNDING_BLOCKED_BY_SPENDING_LIMIT = 'FUNDING_BLOCKED_BY_SPENDING_LIMIT';

// API Key section
export const API_KEY_GENERATE_CLICKED = 'API_KEY_GENERATE_CLICKED';

// Multi-Package Shipments
export const MULTI_PACKAGE_MODAL_OPEN_FROM_ORDER_DETAILS = 'MULTI_PACKAGE_MODAL_OPEN_FROM_ORDER_DETAILS';
export const MULTI_PACKAGE_MODAL_OPEN_FROM_ORDER_SIDEBAR = 'MULTI_PACKAGE_MODAL_OPEN_FROM_ORDER_SIDEBAR';
export const MULTI_PACKAGE_MODAL_OPEN_FROM_SHIPMENT_SECTION = 'MULTI_PACKAGE_MODAL_OPEN_FROM_SHIPMENT_SECTION';
export const MULTI_PACKAGE_DROPDOWN_SELECT_FROM_ORDER_DETAILS = 'MULTI_PACKAGE_DROPDOWN_SELECT_FROM_ORDER_DETAILS';
export const MULTI_PACKAGE_DROPDOWN_SELECT_FROM_ORDER_SIDEBAR = 'MULTI_PACKAGE_DROPDOWN_SELECT_FROM_ORDER_SIDEBAR';
export const BULK_MULTI_PACKAGE_SET_SELECT_FROM_BULK_MODAL = 'BULK_MULTI_PACKAGE_SET_SELECT_FROM_BULK_MODAL';
export const BULK_MULTI_PACKAGE_SET_SELECT_FROM_ORDERS_DRAWER = 'BULK_MULTI_PACKAGE_SET_SELECT_FROM_ORDERS_DRAWER';

// Multi-Package Shipments Modal interactions
export const MULTI_PACKAGE_ADD_PACKAGE_CLICKED = 'MULTI_PACKAGE_ADD_PACKAGE_CLICKED';
export const MULTI_PACKAGE_APPLY_PACKAGE_SET_CLICKED = 'MULTI_PACKAGE_APPLY_PACKAGE_SET_CLICKED';
export const MULTI_PACKAGE_APPLY_PACKAGE_SET_DELETED = 'MULTI_PACKAGE_APPLY_PACKAGE_SET_DELETED';
export const MULTI_PACKAGE_DUPLICATE_CLICKED = 'MULTI_PACKAGE_DUPLICATE_CLICKED';
export const MULTI_PACKAGE_DELETE_CLICKED = 'MULTI_PACKAGE_DELETE_CLICKED';
export const MULTI_PACKAGE_SAVE_WITH_PACKAGE_SET = 'MULTI_PACKAGE_SAVE_WITH_PACKAGE_SET';
export const MULTI_PACKAGE_SAVE_PACKAGES_CLICKED = 'MULTI_PACKAGE_SAVE_PACKAGES_CLICKED';
export const MULTI_PACKAGE_CUSTOM_PACKAGE_TYPE_SELECTED = 'MULTI_PACKAGE_CUSTOM_PACKAGE_TYPE_SELECTED';

// Demo Order Events
export const CREATE_DEMO_ORDER_BUTTON_CLICKED = 'CREATE_DEMO_ORDER_BUTTON_CLICKED';
export const DEMO_ORDER_DEACTIVATE_CLICKED = 'DEMO_ORDER_DEACTIVATE_CLICKED';

// Test Label Events
export const TEST_LABEL_BUTTON_CLICKED = 'TEST_LABEL_BUTTON_CLICKED';
// MFA Step up authentication
export const MFA_STEP_UP_PASSWORD_CHALLENGE = 'MFA_STEP_UP_PASSWORD_CHALLENGE';
export const MFA_STEP_UP_CODE_CHALLENGE = 'MFA_STEP_UP_CODE_CHALLENGE';
export const MFA_STEP_UP_SUCCESS = 'MFA_STEP_UP_SUCCESS';

// SRC (Shipping Rate Calculator) Events
export const SRC_GET_RATES_CLICKED = 'SRC_GET_RATES_CLICKED';
export const SRC_INPUT_CHANGED = 'SRC_INPUT_CHANGED';

// FTU Wizard Help Center Events
export const WIZARD_HELP_CALL_CLICKED = 'WIZARD_HELP_CALL_CLICKED';
export const WIZARD_HELP_CHAT_CLICKED = 'WIZARD_HELP_CHAT_CLICKED';
export const WIZARD_HELP_EMAIL_CLICKED = 'WIZARD_HELP_EMAIL_CLICKED';

// Returns (Legacy and Enhanced)
export const DEACTIVATE_ENHANCED_RETURNS_CLICK = 'DEACTIVATE_ENHANCED_RETURNS_CLICK';
export const RETURN_ACTION_PROCESS_RETURN_CLICKED = 'RETURN_ACTION_PROCESS_RETURN_CLICKED';
export const RETURN_ACTION_APPROVE_CLICKED = 'RETURN_ACTION_APPROVE_CLICKED';
export const RETURN_ACTION_CANCEL_CLICKED = 'RETURN_ACTION_CANCEL_CLICKED';
export const RETURN_ACTION_COPY_TRACKING_NUMBER_CLICKED = 'RETURN_ACTION_COPY_TRACKING_NUMBER_CLICKED';
export const RETURN_ACTION_MARK_RECEIVED_CLICKED = 'RETURN_ACTION_MARK_RECEIVED_CLICKED';
export const RETURN_ACTION_PRINT_LABEL_CLICKED = 'RETURN_ACTION_PRINT_LABEL_CLICKED';
export const RETURN_ACTION_REJECT_CLICKED = 'RETURN_ACTION_REJECT_CLICKED';
export const RETURN_ACTION_SEND_LABEL_CLICKED = 'RETURN_ACTION_SEND_LABEL_CLICKED';
export const RETURN_ACTION_SEND_PAYMENT_REMINDER_CLICKED = 'RETURN_ACTION_SEND_PAYMENT_REMINDER_CLICKED';
export const RETURN_ACTION_VIEW_MARKETPLACE_CLICKED = 'RETURN_ACTION_VIEW_MARKETPLACE_CLICKED';
export const RETURN_ACTION_VOID_LABEL_CLICKED = 'RETURN_ACTION_VOID_LABEL_CLICKED';
export const RETURN_ACTION_NOTE_FORM_SUBMITTED = 'RETURN_ACTION_NOTE_FORM_SUBMITTED';
export const RETURN_ACTION_NOTE_DELETE_CLICKED = 'RETURN_ACTION_NOTE_DELETE_CLICKED';
export const RETURN_ITEM_RESTOCK_OPTION_SELECTED = 'RETURN_ITEM_RESTOCK_OPTION_SELECTED';
export const RETURN_ITEM_APPROVE_REJECT_DECISION_SELECTED = 'RETURN_ITEM_APPROVE_REJECT_DECISION_SELECTED';
export const RETURN_SIDEBAR_CLICKED = 'RETURN_SIDEBAR_CLICKED';
export const RETURNS_GRID_CLEAR_FILTER = 'RETURNS_GRID_CLEAR_FILTER';
export const RETURNS_GRID_RELOAD = 'RETURNS_GRID_RELOAD';
export const RETURNS_GRID_SELECT_FILTER = 'RETURNS_GRID_SELECT_FILTER';
export const RETURNS_GRID_SELECT_STATUS_TAB = 'RETURNS_GRID_SELECT_STATUS_TAB';
export const RETURNS_GRID_SIDEBAR_CLEAR_QUICK_SEARCH = 'RETURNS_GRID_SIDEBAR_CLEAR_QUICK_SEARCH';
export const RETURNS_GRID_SIDEBAR_QUICK_SEARCH = 'RETURNS_GRID_SIDEBAR_QUICK_SEARCH';
export const RETURNS_GRID_SIDEBAR_SELECT_STORE = 'RETURNS_GRID_SIDEBAR_SELECT_STORE';
export const RETURNS_GRID_PRINT_LABEL = 'RETURNS_GRID_PRINT_LABEL';
export const RETURNS_GRID_VOID_LABEL = 'RETURNS_GRID_VOID_LABEL';
export const RETURNS_GRID_UPDATE_TRACKING = 'RETURNS_GRID_UPDATE_TRACKING';
export const RETURNS_GRID_MARK_AS_RECEIVED = 'RETURNS_GRID_MARK_AS_RECEIVED';
export const RETURNS_GRID_RESEND_RETURN_LABEL = 'RETURNS_GRID_RESEND_RETURN_LABEL';

// Purchase Orders
export const PURCHASE_ORDER_ACTION_CREATE_NEW_CLICKED = 'PURCHASE_ORDER_ACTION_CREATE_NEW_CLICKED';
export const PURCHASE_ORDER_ACTION_SAVE_NEW_CLICKED = 'PURCHASE_ORDER_ACTION_SAVE_NEW_CLICKED';
export const PURCHASE_ORDER_ACTION_SAVE_EDIT_CLICKED = 'PURCHASE_ORDER_ACTION_SAVE_EDIT_CLICKED';
export const PURCHASE_ORDER_ACTION_DUPLICATE = 'PURCHASE_ORDER_ACTION_DUPLICATE';
export const PURCHASE_ORDER_ACTION_STATUS_CHANGED = 'PURCHASE_ORDER_ACTION_STATUS_CHANGED';

// Transfer Orders
export const TRANSFER_ORDER_ACTION_CREATE_NEW_CLICKED = 'TRANSFER_ORDER_ACTION_CREATE_NEW_CLICKED';
export const TRANSFER_ORDER_ACTION_SAVE_NEW_CLICKED = 'TRANSFER_ORDER_ACTION_SAVE_NEW_CLICKED';
export const TRANSFER_ORDER_ACTION_SAVE_EDIT_CLICKED = 'TRANSFER_ORDER_ACTION_SAVE_EDIT_CLICKED';
export const TRANSFER_ORDER_ACTION_SAVE_NEW_DRAFT_CLICKED = 'TRANSFER_ORDER_ACTION_SAVE_NEW_DRAFT_CLICKED';
export const TRANSFER_ORDER_ACTION_SAVE_EDIT_DRAFT_CLICKED = 'TRANSFER_ORDER_ACTION_SAVE_EDIT_DRAFT_CLICKED';
export const TRANSFER_ORDER_ACTION_STATUS_CHANGED = 'TRANSFER_ORDER_ACTION_STATUS_CHANGED';
export const TRANSFER_ORDER_ACTION_RECEIVE_CLICKED = 'TRANSFER_ORDER_ACTION_RECEIVE_CLICKED';
export const TRANSFER_ORDER_ACTION_RECEIVE_SAVED = 'TRANSFER_ORDER_ACTION_RECEIVE_SAVED';

// Inventory — Units of Measure (UoM)
export const INVENTORY_UOM_PO_SAVED_WITH_UOM = 'INVENTORY_UOM_PO_SAVED_WITH_UOM';
export const INVENTORY_UOM_SCAN_TO_RECEIVE_SUBMITTED_WITH_UOM = 'INVENTORY_UOM_SCAN_TO_RECEIVE_SUBMITTED_WITH_UOM';
export const INVENTORY_UOM_UNIT_SAVED = 'INVENTORY_UOM_UNIT_SAVED';
export const INVENTORY_UOM_UNIT_DELETED = 'INVENTORY_UOM_UNIT_DELETED';
export const INVENTORY_UOM_BARCODES_PRINTED = 'INVENTORY_UOM_BARCODES_PRINTED';
export const INVENTORY_UOM_DELETE_BLOCKED = 'INVENTORY_UOM_DELETE_BLOCKED';
export const INVENTORY_UOM_SCAN_MATCHED_BY_UOM = 'INVENTORY_UOM_SCAN_MATCHED_BY_UOM';
export const INVENTORY_UOM_TO_SAVED_WITH_UOM = 'INVENTORY_UOM_TO_SAVED_WITH_UOM';
export const INVENTORY_UOM_TO_RECEIVED_WITH_UOM = 'INVENTORY_UOM_TO_RECEIVED_WITH_UOM';
export const INVENTORY_UOM_TO_SCAN_MATCHED_BY_UOM = 'INVENTORY_UOM_TO_SCAN_MATCHED_BY_UOM';

// Todo Card Events
export const TODO_CHECKED = 'TODO_CHECKED';
export const TODO_REMOVED = 'TODO_REMOVED';
export const TODO_NAV_CLICKED = 'TODO_NAV_CLICKED';
export const TODO_ACTION_CLICKED = 'TODO_ACTION_CLICKED';
export const TODO_MARKED_COMPLETE = 'TODO_MARKED_COMPLETE';

// Returns Settings Events
export const RETURNS_STORE_ACTIVATE_CLICKED = 'RETURNS_STORE_ACTIVATE_CLICKED';
export const RETURNS_DAYS_ENTERED = 'RETURNS_DAYS_ENTERED';
export const RETURNS_SERVICE_SELECTED = 'RETURNS_SERVICE_SELECTED';
export const RETURNS_PACKAGE_SELECTED = 'RETURNS_PACKAGE_SELECTED';
export const RETURNS_PORTAL_URL_COPIED = 'RETURNS_PORTAL_URL_COPIED';
export const RETURN_POLICY_MESSAGE_UPDATED = 'RETURN_POLICY_MESSAGE_UPDATED';
export const RETURN_EMAIL_MESSAGE_UPDATED = 'RETURN_EMAIL_MESSAGE_UPDATED';

// Automation Recommendations
export const AUTOMATION_RECOMMENDATION_BANNER_SHOWN = 'AUTOMATION_RECOMMENDATION_BANNER_SHOWN';
export const AUTOMATION_RECOMMENDATION_BANNER_CLICKED = 'AUTOMATION_RECOMMENDATION_BANNER_CLICKED';
export const AUTOMATION_RECOMMENDATION_RECOMMENDATIONS_SHOWN = 'AUTOMATION_RECOMMENDATION_RECOMMENDATIONS_SHOWN';
export const AUTOMATION_RECOMMENDATION_EXPLANATION_CLICKED = 'AUTOMATION_RECOMMENDATION_EXPLANATION_CLICKED';
export const AUTOMATION_RECOMMENDATION_CONTACT_FORM_LOADED = 'AUTOMATION_RECOMMENDATION_CONTACT_FORM_LOADED';

// Reorder Assist (Forecasting Drawer) Events
export const REORDER_ASSIST_EVENT = 'REORDER_ASSIST_EVENT';

// ShipStation Analytics Events
export const SHIPSTATION_ANALYTICS_DASHBOARD_CLICK = 'SHIPSTATION_ANALYTICS_DASHBOARD_CLICK';
export const SHIPSTATION_ANALYTICS_DASHBOARD_FILTER = 'SHIPSTATION_ANALYTICS_DASHBOARD_FILTER';
export const SHIPSTATION_ANALYTICS_DASHBOARD_EXPORT = 'SHIPSTATION_ANALYTICS_DASHBOARD_EXPORT';
export const ANALYTICS_DASHBOARD_VIEWED = 'Analytics Dashboard Viewed';
export const ANALYTICS_DASHBOARD_CREATED = 'Analytics Dashboard Created';
export const ANALYTICS_DASHBOARD_EDITED = 'Analytics Dashboard Edited';
export const ANALYTICS_DASHBOARD_DELETED = 'Analytics Dashboard Deleted';
export const ANALYTICS_EXPLORE_VIEWED = 'Analytics Explore Viewed';

// Inventory Warehouses - Totes Events
export const TOTES_TAB_CLICKED = 'TOTES_TAB_CLICKED';
export const TOTES_PRINT_CLICKED = 'TOTES_PRINT_CLICKED';
export const TOTES_DELETE_CLICKED = 'TOTES_DELETE_CLICKED';
export const TOTES_CREATE_CLICKED = 'TOTES_CREATE_CLICKED';
export const TOTES_TABLE_ACTION_CLICKED = 'TOTES_TABLE_ACTION_CLICKED';
export const TOTES_CANCEL_CLICKED = 'TOTES_CANCEL_CLICKED';
export const CUSTOM_PACKAGES_EXPORT_CLICKED = 'CUSTOM_PACKAGES_EXPORT_CLICKED';
export const TOTE_ADDED_ONE_AT_TIME = 'TOTE_ADDED_ONE_AT_TIME';
export const TOTES_GENERATED = 'TOTES_GENERATED';
export const TOTES_CREATED = 'TOTES_CREATED';
export const TOTES_CREATED_AND_PRINTED = 'TOTES_CREATED_AND_PRINTED';
export const TOTES_CREATED_WITH_FAILED = 'TOTES_CREATED_WITH_FAILED';

export const USPS_NSA_MODAL_VIEW = 'USPS NSA Modal Viewed';
export const USPS_NSA_MODAL_CLOSE = 'USPS NSA Modal Closed';
export const USPS_NSA_BANNER_CLICK = 'USPS NSA Banner Clicked';

export const REFUND_ASSIST_ENABLE_TOGGLE = 'REFUND_ASSIST_ENABLE_TOGGLE';
export const REFUND_ASSIST_EXCLUDE_BUTTON_CLICK = 'REFUND_ASSIST_EXCLUDE_BUTTON_CLICK';

export const SAVE_CONFIG_AND_RATE = 'SAVE_CONFIG_AND_RATE';

// Insurance
export const INSURANCE_FIELD_TOGGLED_CSW = 'INSURANCE_FIELD_TOGGLED_CSW';
export const INSURANCE_FIELD_CLICKED_CSW = 'INSURANCE_FIELD_CLICKED_CSW';
export const INSURANCE_FIELD_CHANGED_CSW = 'INSURANCE_FIELD_CHANGED_CSW';
export const INSURANCE_VALUE_CHANGED_CSW = 'INSURANCE_VALUE_CHANGED_CSW';
export const INSURANCE_AUTO_APPLY_CLICKED_CSW = 'INSURANCE_AUTO_APPLY_CLICKED_CSW';
export const INSURANCE_APPLY_FUTURE_DECISION_CLICKED_CSW = 'INSURANCE_APPLY_FUTURE_DECISION_CLICKED_CSW';

// AI Automation Rule Events
export const AI_AUTOMATION_RULE_DRAFT_CLICKED = 'AI_AUTOMATION_RULE_DRAFT_CLICKED';
export const AI_AUTOMATION_RULE_DRAFT_COMPLETE = 'AI_AUTOMATION_RULE_DRAFT_COMPLETE';
export const AI_AUTOMATION_RULE_DRAFT_ERROR = 'AI_AUTOMATION_RULE_DRAFT_ERROR';

// Customer Management Events
export const CUSTOMER_CREATED = 'CUSTOMER_CREATED';
export const CUSTOMER_UPDATED = 'CUSTOMER_UPDATED';

// Branding Settings Events (source: 'SELLER_BRANDING' | 'STORE_BRANDING')
export const BRANDING_CUSTOM_TEMPLATE_TOGGLE = 'BRANDING_CUSTOM_TEMPLATE_TOGGLE';
export const BRANDING_CUSTOM_COLORS_TOGGLE = 'BRANDING_CUSTOM_COLORS_TOGGLE';
export const BRANDING_SHOW_LOGO_TOGGLE = 'BRANDING_SHOW_LOGO_TOGGLE';
export const BRANDING_SHOW_SOCIAL_TOGGLE = 'BRANDING_SHOW_SOCIAL_TOGGLE';
export const BRANDING_SHOW_SERVICE_MENU_TOGGLE = 'BRANDING_SHOW_SERVICE_MENU_TOGGLE';
export const BRANDING_SHOW_PROMO_IMAGE_TOGGLE = 'BRANDING_SHOW_PROMO_IMAGE_TOGGLE';
export const BRANDING_SHOW_ORDER_DETAILS_TOGGLE = 'BRANDING_SHOW_ORDER_DETAILS_TOGGLE';
export const BRANDING_SAVE_CLICK = 'BRANDING_SAVE_CLICK';
export const BRANDING_PREVIEW_CLICK = 'BRANDING_PREVIEW_CLICK';
export const BRANDING_MORE_LESS_CLICK = 'BRANDING_MORE_LESS_CLICK';
export const BRANDING_OVERRIDE_SETTINGS_TOGGLE = 'BRANDING_OVERRIDE_SETTINGS_TOGGLE';

// Branding Order Details Sub-Settings Events
export const BRANDING_SHOW_ITEM_IMAGES_TOGGLE = 'BRANDING_SHOW_ITEM_IMAGES_TOGGLE';
export const BRANDING_SHOW_ITEM_SKUS_TOGGLE = 'BRANDING_SHOW_ITEM_SKUS_TOGGLE';
export const BRANDING_SHOW_PRICES_TOGGLE = 'BRANDING_SHOW_PRICES_TOGGLE';

// Branding Promo Image Events
export const BRANDING_PROMO_IMAGE_MODAL_OPEN = 'BRANDING_PROMO_IMAGE_MODAL_OPEN';

// Branding Layout Events
export const BRANDING_CHANGE_LAYOUT_MODAL_OPEN = 'BRANDING_CHANGE_LAYOUT_MODAL_OPEN';

// Branding Service Menu Sub-Settings Events
export const BRANDING_SHOW_WEBSITE_TOGGLE = 'BRANDING_SHOW_WEBSITE_TOGGLE';
export const BRANDING_ADDITIONAL_LINKS_TOGGLE = 'BRANDING_ADDITIONAL_LINKS_TOGGLE';
export const BRANDING_SHOW_RETURN_POLICY_TOGGLE = 'BRANDING_SHOW_RETURN_POLICY_TOGGLE';
export const BRANDING_SHOW_CONTACT_INFO_TOGGLE = 'BRANDING_SHOW_CONTACT_INFO_TOGGLE';
export const BRANDING_SHOW_CONTACT_EMAIL_TOGGLE = 'BRANDING_SHOW_CONTACT_EMAIL_TOGGLE';
export const BRANDING_SHOW_CONTACT_PHONE_TOGGLE = 'BRANDING_SHOW_CONTACT_PHONE_TOGGLE';

// Notification Hub Events
export const ALERTS_PANEL_OPENED = 'ALERTS_PANEL_OPENED';
export const ALERTS_PANEL_CLOSED = 'ALERTS_PANEL_CLOSED';
export const ALERTS_PANEL_MARKED_READ = 'ALERTS_PANEL_MARKED_READ';
export const ALERTS_PANEL_MARKED_ALL_READ = 'ALERTS_PANEL_MARKED_ALL_READ';
export const ALERTS_PANEL_FILTERED_VIEW = 'ALERTS_PANEL_FILTERED_VIEW';
export const ALERTS_PANEL_ALERT_LINK_CLICKED = 'ALERTS_PANEL_ALERT_LINK_CLICKED';

// Automation Hub Events
export const AUTOMATION_HUB_PLAYBOOK_RULE_SAVED = 'AUTOMATION_HUB_PLAYBOOK_RULE_SAVED';
export const AUTOMATION_HUB_TOOL_CLICKED = 'AUTOMATION_HUB_TOOL_CLICKED';
export const AUTOMATION_HUB_LEARN_MORE_CLICKED = 'AUTOMATION_HUB_LEARN_MORE_CLICKED';
export const AUTOMATION_HUB_TOOLS_FILTERED = 'AUTOMATION_HUB_TOOLS_FILTERED';

// Seller Recommendations
export const SELLER_RECOMMENDATION_DISPLAYED = 'SELLER_RECOMMENDATION_DISPLAYED';
export const SELLER_RECOMMENDATION_DISMISSED = 'SELLER_RECOMMENDATION_DISMISSED';
export const SELLER_RECOMMENDATION_ACTIONED = 'SELLER_RECOMMENDATION_ACTIONED';
export const SELLER_RECOMMENDATION_LEARN_MORE_CLICKED = 'SELLER_RECOMMENDATION_LEARN_MORE_CLICKED';

// Phone Number Capture
export const PHONE_CAPTURE_MODAL_OPENED = 'PHONE_CAPTURE_MODAL_OPENED';
export const PHONE_CAPTURE_MODAL_DISMISSED = 'PHONE_CAPTURE_MODAL_DISMISSED';
export const PHONE_CAPTURE_MODAL_SUBMITTED = 'PHONE_CAPTURE_MODAL_SUBMITTED';
export const PHONE_CAPTURE_MODAL_SUBMIT_FAILED = 'PHONE_CAPTURE_MODAL_SUBMIT_FAILED';
export const PHONE_CAPTURE_BANNER_CLICKED = 'PHONE_CAPTURE_BANNER_CLICKED';
export const PHONE_CAPTURE_BANNER_DISMISSED = 'PHONE_CAPTURE_BANNER_DISMISSED';
export const PHONE_CAPTURE_SETTINGS_SAVE = 'PHONE_CAPTURE_SETTINGS_SAVE';
export const FTU_PHONE_CAPTURE_SAVE = 'FTU_PHONE_CAPTURE_SAVE';
export const FTU_PHONE_CAPTURE_SKIP = 'FTU_PHONE_CAPTURE_SKIP';

// Automation Workflow Events
export const AUTOMATION_WORKFLOW_TAB_VIEWED = 'AUTOMATION_WORKFLOW_TAB_VIEWED';
export const AUTOMATION_WORKFLOW_DRAWER_OPENED = 'AUTOMATION_WORKFLOW_DRAWER_OPENED';
export const AUTOMATION_WORKFLOW_DRAWER_CANCELLED = 'AUTOMATION_WORKFLOW_DRAWER_CANCELLED';
export const AUTOMATION_WORKFLOW_CREATED = 'AUTOMATION_WORKFLOW_CREATED';
export const AUTOMATION_WORKFLOW_UPDATED = 'AUTOMATION_WORKFLOW_UPDATED';
export const AUTOMATION_WORKFLOW_DELETED = 'AUTOMATION_WORKFLOW_DELETED';
export const AUTOMATION_WORKFLOW_TOGGLED = 'AUTOMATION_WORKFLOW_TOGGLED';

// Stock Audit Events
export const STOCK_AUDIT_CREATED = 'STOCK_AUDIT_CREATED';
export const STOCK_AUDIT_UPDATED = 'STOCK_AUDIT_UPDATED';
export const STOCK_AUDIT_CANCELLED = 'STOCK_AUDIT_CANCELLED';

// ShipStation Connect Events
export const CONNECT_DOWNLOAD_CLICKED = 'CONNECT_DOWNLOAD_CLICKED';

// Picking & Packing Settings Events
export const PICKING_SETTINGS_VIEWED = 'PICKING_SETTINGS_VIEWED';
export const PICKING_SETTINGS_SAVED = 'PICKING_SETTINGS_SAVED';
export const PACKING_SETTINGS_VIEWED = 'PACKING_SETTINGS_VIEWED';
export const PACKING_SETTINGS_SAVED = 'PACKING_SETTINGS_SAVED';

// Batch Picking Events
export const STOP_PICKING_CLICKED = 'STOP_PICKING_CLICKED';
export const STOP_PICKING_COMPLETE = 'STOP_PICKING_COMPLETE';
export const STOP_PICKING_ERROR = 'STOP_PICKING_ERROR';
export const STOP_PICKING_CANCELLED = 'STOP_PICKING_CANCELLED';

// Operations Snapshots
export const OPERATIONS_CARD_DISPLAYED = 'OPERATIONS_CARD_DISPLAYED';
export const OPERATIONS_CARD_CLICKED = 'OPERATIONS_CARD_CLICKED';
export const OPERATIONS_CARD_CONFIGURATION_STARTED = 'OPERATIONS_CARD_CONFIGURATION_STARTED';
export const OPERATIONS_CARD_CONFIGURATION_COMPLETE = 'OPERATIONS_CARD_CONFIGURATION_COMPLETE';
export const OPERATIONS_TABLE_DISPLAYED = 'OPERATIONS_TABLE_DISPLAYED';
export const OPERATIONS_TABLE_VIEW_ALL_CLICKED = 'OPERATIONS_TABLE_VIEW_ALL_CLICKED';
export const OPERATIONS_TABLE_ROW_CLICKED = 'OPERATIONS_TABLE_ROW_CLICKED';

// Packing Recommendations Events
export const PACKING_RECOMMENDATION_REQUESTED = 'PACKING_RECOMMENDATION_REQUESTED';
export const PACKING_RECOMMENDATION_SHOWN = 'PACKING_RECOMMENDATION_SHOWN';
export const PACKING_RECOMMENDATION_APPLIED = 'PACKING_RECOMMENDATION_APPLIED';
export const PACKING_RECOMMENDATION_DISMISSED = 'PACKING_RECOMMENDATION_DISMISSED';
export const PACKING_RECOMMENDATION_RERUN_CLICKED = 'PACKING_RECOMMENDATION_RERUN_CLICKED';
export const PACKING_RECOMMENDATION_OVERRIDDEN = 'PACKING_RECOMMENDATION_OVERRIDDEN';
export const PACKING_RECOMMENDATION_WARNING_ACKNOWLEDGED = 'PACKING_RECOMMENDATION_WARNING_ACKNOWLEDGED';

// Plan Migration Welcome Modal Events
export const PLAN_MIGRATION_MODAL_OPENED = 'PLAN_MIGRATION_MODAL_OPENED';
export const PLAN_MIGRATION_MODAL_CLOSED = 'PLAN_MIGRATION_MODAL_CLOSED';

// Serial Number Events (SPD-26598)
export const SERIAL_NUMBER_ASSIGNED_TO_ORDER = 'SERIAL_NUMBER_ASSIGNED_TO_ORDER';
export const SERIAL_NUMBER_DELETED_FROM_ORDER = 'SERIAL_NUMBER_DELETED_FROM_ORDER';
export const SERIAL_NUMBER_EDITED_ON_ORDER = 'SERIAL_NUMBER_EDITED_ON_ORDER';
export const SERIAL_NUMBER_REPORT_RUN = 'SERIAL_NUMBER_REPORT_RUN';
export const SERIAL_NUMBER_CAPTURE_ABANDONED = 'SERIAL_NUMBER_CAPTURE_ABANDONED';

// Homepage Quick Links
export const HOME_PAGE_QUICK_LINK_CLICKED = 'HOME_PAGE_QUICK_LINK_CLICKED';

// Parcel Oversize/Overweight Events
export const PARCEL_OVERSIZE_OVERWEIGHT_ERROR_SHOWN = 'PARCEL_OVERSIZE_OVERWEIGHT_ERROR_SHOWN';

// Freight/LTL Settings Events
export const LTL_FREIGHT_PROVIDERS_TAB_VIEWED = 'LTL_FREIGHT_PROVIDERS_TAB_VIEWED';
